"use client"
import * as React from "react"
import { cn } from "@/lib/utils"

// Minimal Aceternity-style subtle grid background effect
export function BackgroundGrid({ className }: { className?: string }) {
  return (
    <div
      className={cn(
        "pointer-events-none absolute inset-0 -z-10 opacity-60",
        className
      )}
    >
      <div
        className={cn(
          "h-full w-full",
          // dotted grid
          "[background:radial-gradient(hsla(0,0%,100%,0.08)_1px,transparent_1px)] [background-size:20px_20px]",
          // soft vignette
          "relative before:absolute before:inset-0 before:bg-gradient-to-b before:from-transparent before:via-transparent before:to-background"
        )}
      />
    </div>
  )
}

export default BackgroundGrid
